import type { ReactNode } from 'react';

/** Renders include fields plus an optional stacked exclude section. */
export const IncludeExcludeFields = ({
  title,
  include,
  exclude,
  className
}: {
  title: ReactNode;
  include: ReactNode;
  exclude?: ReactNode;
  className?: string;
}) => (
  <div className={className ?? 'flex flex-col gap-2'}>
    {title}
    {include}
    {exclude != null && (
      <div className='flex flex-col gap-1'>
        <p className='text-xs text-muted-foreground'>Exclude</p>
        {exclude}
      </div>
    )}
  </div>
);
